module.exports = __webpack_public_path__ + "img/passport.3bc8dd48.jpg";